import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const DefaultBarHeightBigSummary = 168;
export const DefaultBarHeightBig = 148;
export const DefaultBarHeight = 90;
export const DefaultBar = styled.div<{ $isScrolled: boolean }>`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	transition: all 0.5s ease;
	padding: ${(props) => (props.$isScrolled ? '0 0 12px 0' : '48px 0 24px 0')};
	flex-direction: column;
	${breakPoints({
		'1024': 'flex-direction: row;',
	})}
`;
